import ReportSection from "../../../components/Food_Repot/ReportSection"
import url from "../../../config/axios";
import { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
const Servicereport=()=>{
const {id}=useParams();
 const [suggestdata, setSuggestdata] = useState();
 
 useEffect(() => {
    url.get(`reportservice/?serviceId=${id}`).then(async (res) => {
    
        setSuggestdata(res.data.reports);
    });
     }, [])
return(<>
<ReportSection title="Report" suggestdata={suggestdata} id={id} />
</>)


}

export default Servicereport